// R38: small "tipo de investigador" tag shown in the directory (grid / table /
// list). The type comes from the estamento slug. The four canonical types get a
// color; any other estamento falls back to its real name with a neutral style,
// so the badge never breaks on unexpected data.

const TIPO_CONFIG: Record<string, { label: string; className: string }> = {
	directivo: { label: 'Directivo', className: 'border-violet-200 bg-violet-50 text-violet-700' },
	academico: { label: 'Académico', className: 'border-blue-200 bg-blue-50 text-blue-700' },
	funcionario: { label: 'Funcionario', className: 'border-slate-200 bg-slate-100 text-slate-600' },
	estudiante: { label: 'Estudiante', className: 'border-teal-200 bg-teal-50 text-teal-700' },
};

const NEUTRAL = 'border-slate-200 bg-slate-100 text-slate-600';

interface TipoInvestigadorBadgeProps {
	/** Estamento slug (directivo | academico | funcionario | estudiante | …). */
	tipo: string | null | undefined;
	/** Estamento display name — fallback label for non-canonical slugs. */
	nombre?: string | null;
	className?: string;
	/**
	 * Font size in px. The grid card passes the zoom-scaled size; every other
	 * caller omits it and keeps the fixed 11px. Without this the badge was the
	 * ONE element of the card that ignored the zoom, so it shrank visually as
	 * everything around it grew.
	 */
	fontSize?: number;
}

export function TipoInvestigadorBadge({
	tipo,
	nombre,
	className = '',
	fontSize,
}: TipoInvestigadorBadgeProps) {
	const cfg = tipo ? TIPO_CONFIG[tipo] : undefined;
	const label = cfg?.label ?? nombre ?? null;
	if (!label) return null;

	return (
		<span
			className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 font-medium leading-none ${
				fontSize === undefined ? 'text-[11px]' : ''
			} ${cfg?.className ?? NEUTRAL} ${className}`}
			style={fontSize === undefined ? undefined : { fontSize: `${fontSize}px` }}
		>
			{label}
		</span>
	);
}
